import { defineStore } from "pinia";
import { onSnapshot } from "firebase/firestore";
import { onValue } from "firebase/database";
import { useAuthStore } from "./auth";
import { useSettingStore } from "./setting";


export const useMenuStore = defineStore({
  id: "menu",
  state: () => {
    return {
      list: [],
      menus: [],
      soldout: {},
      secondMenu:false,
      unSubscribedMenu:null,
      unSubscribedSoldout:null 
    };
  },
  actions: {
    init() {
      this.watchRealtimeMenu()
      this.watchRealtimeSoldout()
    },

    watchRealtimeMenu() {
      const { productsRef } = useFirebaseXtable();
      const ref = productsRef()
      onValue(ref, (snapshot) => {
        const product = snapshot.val()
        this.list = product.list
        this.menus = product.computed
      });
    },    

    watchRealtimeSoldout() {
      if (this.unSubscribedSoldout) {
        return;
      }

      let { subCollectionDocIdRef } = useFirestoreXtable();
      let ordersRef = subCollectionDocIdRef("appState", "soldout");

      let unsubscribe =  onSnapshot(ordersRef, (docSnap) => {
        if (docSnap.exists()) {
          this.soldout = docSnap.data();
        } else {
          console.log("No such document Soldout!");
        }
      });
   
      this.unSubscribedSoldout  = unsubscribe
    },
    setSecondMenu(value:boolean){
     this.secondMenu = value;
    }
  },

  getters: {
    getMenuGroup(state){
      const authStore = useAuthStore();
      const settingStore = useSettingStore();
     

      let _token = authStore.token;
      let productIdMap =
        settingStore.findMenuSetting(_token?.settingId)?.value || {};
    
      let res = useQrcodeMenuSetting(this.menus, productIdMap, _token?.type);
      return res.groups?.value || [];
    }
  },
});
